module.exports = __webpack_public_path__ + "img/warnings-05.7e0d9bbd.png";